var _path, _path2, _line, _line2, _line3, _line4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUnlink = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m18.84 12.25 1.72-1.71h-.02a5.004 5.004 0 0 0-.12-7.07 5.006 5.006 0 0 0-6.95 0l-1.72 1.71"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m5.17 11.75-1.71 1.71a5.004 5.004 0 0 0 .12 7.07 5.006 5.006 0 0 0 6.95 0l1.71-1.71"
})), _line || (_line = /*#__PURE__*/React.createElement("line", {
  x1: 8,
  x2: 8,
  y1: 2,
  y2: 5
})), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
  x1: 2,
  x2: 5,
  y1: 8,
  y2: 8
})), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
  x1: 16,
  x2: 16,
  y1: 19,
  y2: 22
})), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
  x1: 19,
  x2: 22,
  y1: 16,
  y2: 16
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgUnlink);
export { ForwardRef as ReactComponent };